// extracted by mini-css-extract-plugin
export default {"emptyPage":"EmptyPage_emptyPage__X432a","title":"EmptyPage_title__SbOSa","subtitle":"EmptyPage_subtitle__mamj8"};